import { useState, memo } from 'react';
import PropTypes from 'prop-types';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import clsx from 'clsx';
import Popover from '../Popover';

const InfoDropdownPopover = ({
  onOpen,
  onClose,
  dropdownTextPlaceholder,
  children,
  alignClass,
  rotate,
  fontSize,
  popoverAlignClass,
  className,
  showChevron,
  triggerClassName,
}) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  const handleOpen = () => {
    setIsPopoverOpen(true);
    onOpen();
  };

  const handleClose = () => {
    setIsPopoverOpen(false);
    onClose();
  };

  const ChevronIcon = isPopoverOpen ? FaChevronUp : FaChevronDown;

  // TODO: refactor to use dropdown component
  return (
    <div className={clsx('relative w-full', className)}>
      <div
        className={clsx(
          fontSize || 'text-xs',
          'text-theme cursor-pointer z-10 flex items-center',
          alignClass,
          triggerClassName,
        )}
        onClick={handleOpen}
        role="button"
        onKeyDown={handleOpen}
        tabIndex="-1"
      >
        {dropdownTextPlaceholder}{' '}
        {showChevron && <ChevronIcon className={clsx('inline-block pl-1 text-theme', rotate)} />}
      </div>
      <Popover
        open={isPopoverOpen}
        close={handleClose}
        widthClass="sm:min-w-80 min-w-56"
        marginClass="mt-1"
        align={popoverAlignClass}
      >
        {children}
      </Popover>
    </div>
  );
};

InfoDropdownPopover.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  dropdownTextPlaceholder: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  alignClass: PropTypes.string,
  rotate: PropTypes.string,
  fontSize: PropTypes.string,
  popoverAlignClass: PropTypes.string,
  className: PropTypes.string,
  showChevron: PropTypes.bool,
  triggerClassName: PropTypes.string,
};

InfoDropdownPopover.defaultProps = {
  children: undefined,
  onOpen: () => {},
  onClose: () => {},
  alignClass: 'justify-end',
  rotate: '',
  fontSize: '',
  popoverAlignClass: undefined,
  className: '',
  showChevron: true,
  triggerClassName: undefined,
};

export default memo(InfoDropdownPopover);
